import { Component, Input, OnDestroy, OnInit, Signal, signal } from '@angular/core';
import { Establishment } from '../../../../../../graphql/generated';
import { AutoAnimateDirective } from '../../../../shared/directives/auto-animate.directive';
import { AppContext } from '../../../services/app-context.service';
import { Router } from '@angular/router';
import { AppService } from '../../../services/app.service';
import { filter, skip, Subject, takeUntil } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { TOTAL_ESTABLISHMENT_ID, TOTAL_ESTABLISHMENT_NAME } from '../../../services/establishment-scope';

@Component({
    selector: 'app-establishment-picker',
    templateUrl: './establishment-picker.component.html',
    styleUrl: './establishment-picker.component.scss',
    imports: [
        AutoAnimateDirective,
    ],
})
export class EstablishmentPickerComponent implements OnInit, OnDestroy {

    private readonly destroyed = new Subject<void>();

    @Input({ transform: (establishments: Establishment[]) => signal(establishments) })
    establishments: Signal<Establishment[]>;

    /**
     * Reading across every establishment at once. Owners and admins only — anyone else sees the
     * establishments they have access to, and a combined figure would either leak the rest or
     * quietly mean something different per person.
     */
    protected readonly canSeeTotal = toSignal(this.appService.isAdminOrOwner$, { initialValue: false });

    protected readonly totalName = TOTAL_ESTABLISHMENT_NAME;

    protected selectTotal() {
        this.appContext.set('establishmentId', TOTAL_ESTABLISHMENT_ID);
        this.router.navigate(['establishment']);
    }

    constructor(
        private readonly appContext: AppContext,
        private readonly appService: AppService,
        private readonly router: Router,
    ) {
    }

    selectEstablishment(establishment: Establishment) {
        this.appContext.set('establishmentId', establishment.id);
        this.router.navigate(['establishment']);
    }

    ngOnInit() {
        this.appService.establishment$
            .pipe(
                takeUntil(this.destroyed),
                filter(Boolean),
                skip(1),
            )
            .subscribe(() => {
                this.router.navigate(['establishment']);
            });
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}
